<script setup>
  import CompleteReport from '@/components/CompleteReport.vue';          
  import ToastHost from '@/components/base/ToastHost.vue';
</script>

<template>
  <Suspense>
    <CompleteReport />
  </Suspense>
  <ToastHost />
</template>
